import React from "react";

import { Close as CloseIcon } from "@mui/icons-material";
import toast, { Toast } from "react-hot-toast";

const styles: { [name: string]: React.CSSProperties } = {
  toastContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    color: "#FFF",
  },
  toastIcon: {
    cursor: "pointer",
    marginLeft: "80px",
    color: "#1D2939",
  },
  toastContainer: {
    padding: "16px 20px",
    width: "640px",
    maxWidth: "none",
    zIndex: "999999",
    borderLeft: "4px solid",
    borderRadius: "8px",
  },
  toastText: {
    fontSize: "16px",
    fontFamily: "Manrope",
    fontWeight: 600,
    color: "#1D2939",
  },
  success: {
    background: "#ECFDF3",
    borderLeftColor: "#12B76A",
  },
  error: {
    background: "#FEF3F2",
    borderLeftColor: "#F04438",
  },
  info: {
    background: "#20639D",
  },
  warning: {
    background: "#F79009",
  },
};

const success = (
  message?: string,
  options?: Partial<
    Pick<
      Toast,
      "id" | "icon" | "duration" | "ariaProps" | "className" | "style" | "position" | "iconTheme"
    >
  >
) => {
  if (validateMessage(message)) {
    return toast(
      (t) => (
        <div style={styles.toastContent} data-cy="toast-success">
          <span style={styles.toastText}>{message}</span>
          <CloseIcon style={styles.toastIcon} onClick={() => toast.dismiss(t.id)} />
        </div>
      ),
      {
        style: { ...styles.toastContainer, ...styles.success },
        className: "notification success",
        duration: options?.duration || 3000, 
        ...options,
      }
    );
  }
};

const error = (
  message?: string,
  options?: Partial<
    Pick<
      Toast,
      "id" | "icon" | "duration" | "ariaProps" | "className" | "style" | "position" | "iconTheme"
    >
  >
) => {
  if (validateMessage(message)) {
    return toast(
      (t) => (
        <div style={styles.toastContent} data-cy="toast-error">
          <span style={styles.toastText}>{message}</span>
          <CloseIcon style={styles.toastIcon} onClick={() => toast.dismiss(t.id)} />
        </div>
      ),
      {
        style: { ...styles.toastContainer, ...styles.error },
        className: "notification error",
        ...options,
      }
    );
  }
};

const warning = (
  message?: string,
  options?: Partial<
    Pick<
      Toast,
      "id" | "icon" | "duration" | "ariaProps" | "className" | "style" | "position" | "iconTheme"
    >
  >
) => {
  if (validateMessage(message)) {
    return toast(
      (t) => (
        <div style={styles.toastContent}>
          <span style={styles.toastText}>{message}</span>
          <CloseIcon style={styles.toastIcon} onClick={() => toast.dismiss(t.id)} />
        </div>
      ),
      {
        style: { ...styles.toastContainer, ...styles.warning },
        className: "notification warning",
        ...options,
      }
    );
  }
};

const info = (
  message?: string,
  options?: Partial<
    Pick<
      Toast,
      "id" | "icon" | "duration" | "ariaProps" | "className" | "style" | "position" | "iconTheme"
    >
  >
) => {
  if (validateMessage(message)) {
    return toast(
      (t) => (
        <div style={styles.toastContent}>
          <span style={styles.toastText}>{message}</span>
          <CloseIcon style={styles.toastIcon} onClick={() => toast.dismiss(t.id)} />
        </div>
      ),
      {
        style: { ...styles.toastContainer, ...styles.info },
        className: "notification info",
        ...options,
      }
    );
  }
};

const validateMessage = (message?: string) => {
  return message && typeof message === "string";
};

export const NotificationToast = { success, error, warning, info };
